import { ClassificationImage } from "@/types/classificationImage.type";
import { Filter, OrderByCondition } from "@/types/filter.type";
import { Pagination } from "@/types/pagination.type";
import axios from "./api";
import { responseHandlerDefault } from "@/utils/handler.util";

export const getClassificationsImage = (
  page?: number,
  size?: number,
  filter?: Filter,
  order?: OrderByCondition
): Promise<Pagination<ClassificationImage>> => {
  const params: { page?: number; size?: number; filter?: Filter; order?: OrderByCondition } = {};
  if (page) {
    params.page = page;
  }
  if (size) {
    params.size = size;
  }
  if (filter) {
    params.filter = filter;
  }
  if (order) {
    params.order = order;
  }

  return axios.get(`/classificationimage/`, { params }).then(responseHandlerDefault);
};

export const getOneClassificationWithImages = (
  classificationId: number
): Promise<ClassificationImage> => {
  const params: { classification?: number } = {};
  if (classificationId) {
    params.classification = classificationId;
  }
  return axios
    .get<ClassificationImage>("/classificationimage/images", { params })
    .then(responseHandlerDefault);
};

export const postClassificationImage = (
  newClassification: ClassificationImage
): Promise<ClassificationImage> => {
  return axios
    .post<ClassificationImage>("/classificationimage/", newClassification)
    .then(responseHandlerDefault);
};

export const getNewCodeClassification = (): Promise<string> => {
  return axios.get<string>("/classificationimage/newcode").then(responseHandlerDefault);
};
